import { useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";

const InstallButton = () => {
    const [deferredPrompt, setDeferredPormpt] = useState(null);
    const [showInstallButton, setShowInstallButton] = useState(false);

    useEffect(() => {
        const handelBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPormpt(e);
            setShowInstallButton(true);
        }
        window.addEventListener("beforeinstallprompt", handelBeforeInstallPrompt)

        return () => {
            window.removeEventListener("beforeinstallprompt", handelBeforeInstallPrompt);
        }
    }, [])
    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(result => {
                if (result.outcome === "accepted") {
                    console.log("user accepted the insatllprompt!");
                } else {
                    console.log("user  didnot accepted the insatllprompt!");

                }
                setDeferredPormpt(null);
                setShowInstallButton(false);
            })

        }

    }
    if (!showInstallButton) {
        return null;
    }

    return (
        <button className="install-button" onClick={handleInstallClick} style={{margin:'1em'}} >
            نصب اپلیکیشن
        </button>
    )
}
export default InstallButton;